import MutationTypes from '@/store/constants/mutations';

export default (store) => (to, from, next) => {
  if (store.getters.isSignedIn && to.query.superToken) {
    console.warn('Signing out from previous session');
    store.commit(MutationTypes.SIGN_OUT);
  }

  if (store.getters.isSignedIn) {
    next('/');
  } else {
    next();
  }
};
